'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/react.production.min.js');
} else {
  module.exports = require('./cjs/react.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./~/react-localize-redux/~/react/index.js
// module id = ./node_modules/react-localize-redux/node_modules/react/index.js
// module chunks = 1